import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { getAppStoreLinks } from "@/api";

const toHttpsUrl = (value) => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  return /^https:\/\//i.test(trimmed) ? trimmed : "";
};

export const useAppStoreLinksStore = defineStore("appStoreLinks", () => {
  const appStoreUrl = ref("");
  const googlePlayUrl = ref("");
  const hasFetched = ref(false);

  const hasLinks = computed(() => !!(appStoreUrl.value || googlePlayUrl.value));

  async function fetchLinks() {
    if (hasFetched.value) return;
    hasFetched.value = true;
    try {
      const { data } = await getAppStoreLinks();
      appStoreUrl.value = toHttpsUrl(data?.app_store_url);
      googlePlayUrl.value = toHttpsUrl(data?.google_play_url);
    } catch {
      hasFetched.value = false;
      appStoreUrl.value = "";
      googlePlayUrl.value = "";
    }
  }

  return { appStoreUrl, googlePlayUrl, hasFetched, hasLinks, fetchLinks };
});
